import { createRouter, createWebHistory,createWebHashHistory, RouteRecordRaw } from 'vue-router'
import home from '@/views/home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'firstScreen',
    meta: {
      Title: "首页",
      HideNavbar: true
    },
    component: () => import("@/views/FirstScreenView.vue")
  },
  {
    path: "/main",
    name: "main",
    meta: {
      Title: "主页面",
      HideNavbar: true
    },
    component: () => import("@/views/MainView.vue")
  },
  {
    path: "/login",
    name: "login",
    meta: {
      Title: "登录",
      HideNavbar: true
    },
    component: () => import("@/views/LoginView.vue")
  },
  {
    path: "/bind_device",
    name: "BindDevice",
    meta: {
      Title: "绑定设备",
      HideNavbar: true
    },
    component: () => import("@/views/BindDeviceView.vue")
  },
  {
    path: '/template',
    name: 'Template',
    component: () => import(/* webpackChunkName: "about" */ "@/views/TemplateView.vue"),
    meta: {
      Title: "模板页",
      HideNavbar: true
    },
  },
  {
    path: '/modify',
    name: 'modify',
    component: () => import(/* webpackChunkName: "about" */ '@/views/personal/ModifyView.vue')
  },
  {
    path: '/deviceList',
    name: 'deviceList',
    meta: {
      Title: "设备列表",
      HideNavbar: false
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/DeviceListView.vue')
  },
  {
    path: '/addUser',
    name: 'addUser',
    meta: {
      Title: "添加用户",
      HideNavbar: false
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/AddUserView.vue')
  },
  {
    path: '/my_template',
    name: 'my_template',
    meta: {
      Title: "我的模板",
      HideNavbar: false
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/MyTemplateView.vue')
  },
  {
    path: '/myResource',
    name: 'myResource',
    meta: {
      Title: "我的资源",
      HideNavbar: false
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/my/MyResourceView.vue')
  },
  {
    path: '/shopping',
    name: 'shopping',
    meta: {
      Title: "商城",
      HideNavbar: false
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/ShoppingView.vue')
  },
  {
    path: '/advertisement_create',
    name: 'create',
    meta: {
      Title: "我的广告",
      HideNavbar: false
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/advertisement/AdvertisementCreateView.vue')
  },
  {
    path: '/rechargeRecord',
    name: 'rechargeRecord',
    component: () => import(/* webpackChunkName: "about" */ '@/views/RechargeRecordView.vue')
  },
  {
    path: '/theme',
    name: 'theme',
    meta: {
      Title: "我的主题",
      HideNavbar: false
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/ThemeView.vue')
  },
  {
    path: '/promotion',
    name: 'promotion',
    component: () => import(/* webpackChunkName: "about" */ '@/views/PromotionView.vue')
  },
  {
    path: '/personalCenter',
    name: 'personalCenter',
    component: () => import(/* webpackChunkName: "about" */ '@/views/my/MyPersonalCenterView.vue')
  }, {
    path: '/consumption',
    name: 'consumption',
    component: () => import(/* webpackChunkName: "about" */ '@/views/ConsumptionView.vue')
  },
  {
    path: '/recharge',
    name: 'recharge',
    meta: {
      Title: "我的余额",
      HideNavbar: false
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/RechargeView.vue')
  },
  {
    path: '/industry',
    name: 'industry',
    meta: {
      Title: "行业标签",
      HideNavbar: false
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/IndustryView.vue')
  },
  {
    path: '/resource',
    name: 'resource',
    meta: {
      Title: "我的资源",
      HideNavbar: false
    },
    component: () => import('@/views/ResourceView.vue')
  },
  {
    path: '/createAccount',
    name: 'createAccount',
    component: () => import(/* webpackChunkName: "about" */ '@/views/CreateAccountView.vue')
  },
  {
    path: '/accountInfo',
    name: 'accountInfo',
    meta: {
      Title: "账号信息",
      HideNavbar: false
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/my/MyAccountInfoView.vue')
  },
  {
    path: '/accountNumber',
    name: 'accountNumber',
    meta: {
      Title: "所属账号",
      HideNavbar: false
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/my/MyAccountNumberView.vue')
  },
  {
    path: '/resourceList',
    name: 'resourceList',
    meta: {
      Title: "记录列表",
      HideNavbar: false
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/ResourceListView.vue')
  },
  {
    path: '/advertisement',
    name: 'advertisement',
    meta: {
      Title: "我的广告",
      HideNavbar: false
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/advertisement/AdvertisementView.vue')
  },
  {
    path: '/templateDetails',
    name: 'templateDetails',
    meta: {
      Title: "模板详情",
      HideNavbar: false
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/TemplateDetailsView.vue')
  },
  {
    path: '/adSquare',
    name: 'adSquare',
    meta: {
      Title: "广告广场",
      HideNavbar: false
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/AdSquareView.vue')
  }
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})
export default router
